<template>
  <div class="about">
    <h1>Consumo de apis</h1>
  </div>
</template>
<script>

import {mapState, mapMutations, mapActions} from 'vuex';
//import {mostrarMensajeErrorCatch, mostrarMensajeInformativo, mostrarMensajeExitoso, mostrarMensajeError} from '../../mixins/mensajes';

export default {
    data() {
        return {
        }
    },

    computed: {
        ...mapState({ 
            catUnidades: state => state.catalogos.catUnidades,
        }),

        ...mapState([ 'cargando' ])
    },

    methods: {
        ...mapActions( 
                'catalogos', [
                    'obtenerUnidades',
                ]
        ),
        ...mapMutations([ 'setearCargando' ]),
        
    },
  
    mounted(){ 
        this.obtenerUnidades(); 
    },
}
</script>